import React from "react";

/**
 * Color-coded status badge used across Mafia/DI tables.
 *
 * Variants map to legacy status semantics:
 *   verified  — MafiaTables.Checked = 1
 *   released  — MafiaTables.Released = 1
 *   inProgress— MafiaTables.InProgress = 1
 *   locked    — MafiaTables.Lock IS NOT NULL
 *   draft     — neither checked nor released
 *   outOfSpec — DI cell outside Min/Max
 *   passed    — DI cell value "-777"
 *   failed    — DI cell value "-999"
 *   ok        — generic success
 *   warn      — generic warning
 *   danger    — generic danger
 *   neutral   — gray
 *
 * Style follows the theme's existing badge-soft conventions
 * (badge-soft-success / badge-soft-warning / etc.) which the dashboard
 * already uses on other pages.
 */
const PRESETS = {
  verified: { className: "badge-soft-success", icon: "ri-check-double-line", label: "Verified" },
  released: { className: "badge-soft-info", icon: "ri-flight-takeoff-line", label: "Released" },
  inProgress: { className: "badge-soft-warning", icon: "ri-loader-2-line", label: "In Progress" },
  locked: { className: "badge-soft-secondary", icon: "ri-lock-line", label: "Locked" },
  draft: { className: "badge-soft-secondary", icon: "ri-draft-line", label: "Draft" },
  outOfSpec: { className: "badge-soft-danger", icon: "ri-error-warning-line", label: "Out of Spec" },
  passed: { className: "badge-soft-success", icon: "ri-checkbox-circle-line", label: "Pass" },
  failed: { className: "badge-soft-danger", icon: "ri-close-circle-line", label: "Fail" },
  ok: { className: "badge-soft-success", icon: "ri-check-line", label: "OK" },
  warn: { className: "badge-soft-warning", icon: "ri-alert-line", label: "Warning" },
  danger: { className: "badge-soft-danger", icon: "ri-error-warning-line", label: "Error" },
  neutral: { className: "badge-soft-secondary", icon: "ri-question-line", label: "" },
};

const StatusBadge = ({ status, label, icon, size = "md" }) => {
  const preset = PRESETS[status] || PRESETS.neutral;
  const text = label || preset.label;
  const iconClass = icon || preset.icon;

  const fontSize = size === "sm" ? 10 : size === "lg" ? 13 : 11;
  const py = size === "sm" ? "2px 6px" : size === "lg" ? "5px 12px" : "4px 9px";

  return (
    <span
      className={`badge ${preset.className} fw-medium`}
      style={{
        fontSize,
        padding: py,
        letterSpacing: "0.02em",
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
      }}
    >
      {iconClass ? <i className={iconClass} style={{ fontSize: fontSize + 1 }} /> : null}
      {text}
    </span>
  );
};

export default React.memo(StatusBadge);
